import { ItineraryService } from 'app/shared/itinerary.service';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { ChangeDetectorRef, Component, OnInit, ViewContainerRef, Inject, PLATFORM_ID, AfterViewInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { Logger } from './core/logger.service';
import { I18nService } from './core/i18n.service';
import { AppService } from './app.service';
import { setting } from '../../setting';
import { UserService } from './pages/com.usblick.common/auth/user.service';
import { AuthService } from './pages/com.usblick.common/auth/auth.service';
import { AgentsService } from './agents/agents.service';
import { first, take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from './core/profiles/storeProfile';
import { selectPermissions } from './core/profiles/profiles.selectors';
import { SeoService } from 'seoService';
import { FidelityService } from './fidelity/fidelity.service';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  public loadSetting: boolean;
  public baseUrl: string;
  public apiBookingUrl: string;
  public domain: string;
  public getClientsSettingAppBooking: any;
  public cssVariableValue: string;
  public clientsSettings: any;
  public agency: any;
  namePaymentCondition: any;
  iconPaymentCondition: any;
  isAgencyPaymentCondition: boolean = false;
  balanceBlickoins: any = 0;
  creditLimits: any = 0;
  creditDeposits: any = 0;
  creditBlickoins: any = 0;
  appLoading: boolean = true;
  faviconUrl: string;

  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private subscription: Subscription;
  private isBrowser: boolean;
  private isServer: boolean;



  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public vcr: ViewContainerRef,
    private titleService: Title,
    private translateService: TranslateService,
    private appService: AppService,
    public userService: UserService,
    private authService: AuthService,
    public agentsService: AgentsService,
    private _itineraryService: ItineraryService,
    private store: Store<AppState>,
    private seoService: SeoService,
    private fidelityService: FidelityService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isServer = isPlatformServer(this.platformId);
  }

      color1: string = '#ffffff';
      color2: string = '#ffffff';
      color3: string = '#ffffff';
      height1: number = 35;
      height2: number = 110;
      height3: number = 77;

  ngAfterViewInit(): void {
    this.setFavicon();
  }

  ngOnInit() {
    // Configuraciones universales (corren en servidor y cliente)
    this.initUniversalConfig();

    // Configuraciones solo para navegador
    if (this.isBrowser) {
      this.initBrowserOnly();
    }

    if (isPlatformBrowser(this.platformId)) {
      this.setBodyBackground();
    }
  }

  setBodyBackground() {
    const gradient = this.getBackgroundGradient();
    this.renderer.setStyle(this.document.body, 'background', 'none');
    this.renderer.setStyle(this.document.body, 'min-height', '100vh');
  }

  getBackgroundGradient(): string {
    const totalHeight = this.height1 + this.height2 + this.height3;
    const mainColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;

    return `linear-gradient(to bottom,
      ${this.color1} 0%,
      ${this.color1} ${this.height1}px,
      ${this.color2} ${this.height1}px,
      ${this.color2} ${this.height1 + this.height2}px,
      ${mainColor} ${this.height1 + this.height2}px,
      ${mainColor} ${totalHeight}px,
      #ffffff ${totalHeight}px)`;
  }

  /**
   * Configuraciones que pueden correr en servidor y cliente
   */
  private initUniversalConfig(): void {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');

    // Configuración de títulos de página (no toca DOM directamente)
    const onNavigationEnd = this.router.events.filter(event => event instanceof NavigationEnd);

    Observable.merge(this.translateService.onLangChange, onNavigationEnd)
      .map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe(event => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });
  }

  /**
   * Configuraciones que SOLO corren en el navegador
   */
  private initBrowserOnly(): void {
    // Carga configuración del cliente
    this.loadSetting = true;
    this.getClientsSettingBooking();

    // Suscripción a actualizaciones de pago
    this.subscription = this._itineraryService.paymentUpdatebalance.subscribe(
      (paymentData) => {
        this.setBalance();
      }
    );

    // Configurar scroll al navegar
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });


    this.getSubscriptionLoading();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Obtiene la configuración del cliente desde localStorage o API
   */
  async getClientsSettingBooking() {
    if (!this.isBrowser) return;

    await this.authService.getCurrenciesExchanges();
    this.getPermissions();

    // Acceso seguro a localStorage
    let clientNameStorage = null;
    try {
      const stored: any = localStorage.getItem(`${setting.name}`);

      const storedParsed = JSON.parse(stored);

      const sectionHeader = JSON.parse(storedParsed?.clients_setting_app_booking?.section_header);
      if(sectionHeader) {
        this.color1 = sectionHeader.top_header;
        this.color2 = sectionHeader.background_1;
        this.color3 = sectionHeader.background_itinerary_owner;

         this.setBodyBackground();
      }

      clientNameStorage = stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.warn('Error accessing localStorage:', e);
    }

    if (clientNameStorage) {
      const clientStorageId = clientNameStorage.id ? clientNameStorage.id : 0;
      const clientStorageUpdatedAt = clientNameStorage?.updated_at ? clientNameStorage?.updated_at : null;
      this.userService.clientIdFusion = clientNameStorage?.id;
      this.getClientApplications(clientStorageId);

      if (clientNameStorage && clientStorageId > 0 && clientStorageUpdatedAt) {
        this.clientsSettings = clientNameStorage;
        this.appService.getConsultUpdatedClient().subscribe({
          next: (res: any) => {
            if (res && res === clientStorageUpdatedAt) {
              this.loadSetting = false;
            } else {
              this.clientSubscription();
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        });
      } else {
        this.clientSubscription();
      }
    } else {
      this.clientSubscription();
    }
  }

  /**
   * Suscripción para obtener configuración del cliente desde API
   */
  clientSubscription(): void {
    if (!this.isBrowser) return;

    this.appService.getClientsSettingAppBooking().subscribe({
      next: (response: any) => {
        if (response && response.id) {
          try {
            localStorage.setItem(setting.name, JSON.stringify(response));
          } catch (e) {
            console.warn('Error writing to localStorage:', e);
          }
          this.clientsSettings = response;
          this.userService.clientIdFusion = this.clientsSettings?.id;

          if (this.clientsSettings.login === 0) {
            this.appLoading = false;
          } else {
            this.getPermissions();
            this.getClientApplications(response.id);
          }
          this.loadSetting = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.loadSetting = false;
        console.log(error);
      }
    });
  }

  /**
   * Configura el favicon de la página
   */
  private setFavicon(): void {
    if (!this.isBrowser) return;

    try {
      const faviconUrl = this.seoService.getFaviconUrl();
      const link: HTMLLinkElement = this.document.querySelector('link[rel="icon"]') || this.document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      link.href = faviconUrl;
      this.document.head.appendChild(link);
    } catch (e) {
      console.warn('Error setting favicon:', e);
    }
  }

  getSubscriptionLoading(): void {
    if (!this.isBrowser) return;

    this._itineraryService.loading$.subscribe((res: boolean) => {
      if (!res) {
        // this.appLoading = false;
      }
    });
  }

  getPermissions(): void {
    this.permissions$ = this.store.select(selectPermissions);
    this.store.dispatch({ type: '[Auth] Load Permissions' });

    this.permissions$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(permissions => {
        this.permissionsMap = this.createPermissionsMap(permissions);
        this.getAgencyData();
      });
  }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      map[permission.name] = permission;
    });
    return map;
  }

     private isBalanceLoading = false;
    private lastBalanceCall = 0;
    private readonly MIN_INTERVAL_MS = 5000; // 5 segundos mínimo entre llamadas
    setBalance() {
        if (!this.isBrowser) {
            this.appLoading = false;
            return;
        }

        // ✅ Evitar llamadas si ya está en ejecución
        if (this.isBalanceLoading) {
            return;
        }

        // ✅ Evitar llamadas muy frecuentes (throttle)
        const now = Date.now();
        if (now - this.lastBalanceCall < this.MIN_INTERVAL_MS) {
            return;
        }
        this.lastBalanceCall = now;

        this.isBalanceLoading = true;

        // ✅ Usar first() para tomar solo el primer valor de activeItinerary
        this._itineraryService.activeItinerary
            .pipe(
                takeUntil(this._unsubscribeAll),
                first() // ✅ Solo toma el primer valor
            )
            .subscribe({
                next: (data: any) => {
                    this.agentsService.getBalanceAgency(
                        this.userService._agencyID,
                        this.userService._agentID
                    )
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe({
                        next: (response: any) => {
                            this.userService.creditsDeposits = parseFloat(response.balanceCreditsDeposits) || 0;
                            this.fidelityService.creditDepositActives = this.userService.creditsDeposits;
                            this.userService.credits = parseFloat(response.balanceCredits) || 0;
                            this.userService.creditLimits = this.userService.credits + this.userService.creditsDeposits;

                            if (response.agent) {
                                this.userService.balanceBlickoins = parseFloat(response.agent?.availableBlickoins) || 0;
                                this.userService.creditBlickoins = parseFloat(response.agent?.availableCreditBlickoins) || 0;
                            } else if (!response.agent) {
                                this.setBalanceBlickoins();
                            }

                            this.appLoading = false;
                            this.creditLimits = this.userService.creditLimits;
                            this.isBalanceLoading = false;
                        },
                        error: (error: HttpErrorResponse) => {
                            console.error('Error en getBalanceAgency:', error);
                            this.appLoading = false;
                            this.isBalanceLoading = false;
                        }
                    });
                },
                error: (error: HttpErrorResponse) => {
                    console.error('Error en activeItinerary:', error);
                    this.appLoading = false;
                    this.isBalanceLoading = false;
                }
            });
    }

    // ✅ Método para forzar actualización (cuando sea necesario)
    forceSetBalance(): void {
        this.lastBalanceCall = 0; // Resetear throttle
        this.setBalance();
    }

  setBalanceBlickoins(): void {
    if (!this.isBrowser) {
      this.appLoading = false;
      return;
    }

    this.agentsService.getBalanceAgent(this.userService._agentID)
      .subscribe({
        next: (response: any) => {
          this.userService.balanceBlickoins = response.availableBlickoins;
          this.userService.creditBlickoins = response.availableCreditBlickoins;
          this.cdr.detectChanges();
          this.appLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.appLoading = false;
        }
      });
  }

  async getAgencyData() {
    this.authService._getAgent(this.permissionsMap);
    this.authService.authInfoLoaded$
      .subscribe({
        next: (res: any) => {
          if (res) {
            if (!this.permissionsMap['booking.ingresosinagencia']) {
              this.creditLimits = this.userService.creditLimits;
              this.isAgencyPaymentCondition = false;
              this.namePaymentCondition = this._itineraryService.paymentConditionName;
              this.iconPaymentCondition = this._itineraryService.paymentConditionIcono;
              this.isAgencyPaymentCondition = true;
            }
          } else {
            this.appLoading = false;
            this.authService.profileSeller$.subscribe({
              next: (res: any) => {
                if (res) {
                  this._itineraryService.consultActiveItinerary(this.userService._agentID, false, this._itineraryService?.itinerary?.id, 'app-component');
                  this.setBalance();
                  if (this.userService?.userActive && this.userService?.userActive?.pay_mode) {
                    this.setAgencyPaymentCondition(this.userService.userActive.pay_mode);
                  }
                }
              }
            });
          }
        }
      });
  }

  // ✅ Flag para evitar llamadas simultáneas
    private isPaymentConditionLoading = false;
    private lastPaymentConditionCall = 0;
    // private readonly MIN_INTERVAL_MS = 5000; // 5 segundos mínimo entre llamadas

    setAgencyPaymentCondition(pay_mode: number) {
        if (!this.isBrowser) return;
        if (!pay_mode) return;

        // ✅ Evitar llamadas si ya está en ejecución
        if (this.isPaymentConditionLoading) {
            return;
        }

        // ✅ Evitar llamadas muy frecuentes (throttle)
        const now = Date.now();
        if (now - this.lastPaymentConditionCall < this.MIN_INTERVAL_MS) {
            return;
        }
        this.lastPaymentConditionCall = now;

        this.isPaymentConditionLoading = true;

        this.agentsService.agencyPaymentConditionByID(pay_mode)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    this.isAgencyPaymentCondition = false;
                    if (response && typeof response === 'object' && response !== null) {
                        this.namePaymentCondition = response.name;
                        this.iconPaymentCondition = response.icono;
                        this.agentsService.paymentConditions = response;
                        this._itineraryService.paymentConditions = response;
                        this.isAgencyPaymentCondition = true;
                    } else {
                        console.error('Invalid payment condition response:', response);
                    }
                    this.isPaymentConditionLoading = false;
                },
                error: (error: HttpErrorResponse) => {
                    console.error('Error loading payment condition:', error);
                    this.isPaymentConditionLoading = false;
                    if (this.isBrowser) {
                        alert('Error al cargar condiciones de pago. Por favor, refresca la página.');
                    }
                }
            });
    }

  getClientApplications(clientId: any): void {
    if (!clientId) return;

    this.appService.clientsApplications(clientId).subscribe({
      next: (res: any) => {
        if (res && res.applications) {
          this.userService._clientsApplications = res.applications;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }
}
